import React, { forwardRef } from 'react';

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: boolean;
}

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className = '', error = false, disabled, ...props }, ref) => {
    return (
      <textarea
        ref={ref}
        disabled={disabled}
        className={`w-full px-4 py-3 rounded-2xl border-2 bg-white text-brand-text-dark text-sm font-medium placeholder-brand-text-muted/50 focus:outline-none transition-all duration-150 resize-y min-h-[100px]
          ${
            error
              ? 'border-brand-error focus:border-brand-error focus:ring-brand-error'
              : 'border-brand-border focus:border-brand-primary focus:ring-brand-primary'
          }
          ${disabled ? 'opacity-50 cursor-not-allowed bg-brand-bg' : ''}
          ${className}`}
        {...props}
      />
    );
  }
);

Textarea.displayName = 'Textarea';

export default Textarea;
